export const FETCH_GLOBAL_SETTINGS_REQUEST = 'FETCH_GLOBAL_SETTINGS_REQUEST';
export const FETCH_GLOBAL_SETTINGS_SUCCESS = 'FETCH_GLOBAL_SETTINGS_SUCCESS';
export const FETCH_GLOBAL_SETTINGS_FAILURE = 'FETCH_GLOBAL_SETTINGS_FAILURE';
